import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostSalesApartment from "./apartment";
import { locationPinCode,shipTolocationPinCode } from "services/redux/sales/corporate/locations/action";
import { clientBillingAddress } from "services/redux/sales/corporate/client/action";

import { postSalesApartmentLead } from "services/redux/sales/postSales/action";
import { postApartment } from "services/redux/sales/postSales/apartment/action";
import {
  documentUploadUrl,
  imageUploadUrl,
  videoUploadUrl,
} from "services/redux/fileUpload/action";
import { getMateriaById,getBrandById } from "services/redux/sales/postSales/corporate/action";
import { supplyNameFun } from "services/redux/sales/corporate/categoryDetails/action";

const mapStateToProps = (state) => ({
  postApartData: state.appartmentPostLeadReducer.postApartData,
  pincodeData: state.locationReducer.pincodeData,
  postApartmentData: state.coporatePostLeadReducer.postApartmentData,
  documentUrlData: state.fileUploadReducer.documentUrlData,
  getMaterial: state.coporatePostLeadReducer.getMaterial,
  getBrand: state.coporatePostLeadReducer.getBrand,
  splNameData: state.categoryDetlReducer.splNameData,
  shipToPincodeData:  state.locationReducer.shipToPincodeData,
  clientBillingPocData: state.clientReducer.billingAddressPoc
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postApartment,
      locationPinCode,
      postSalesApartmentLead,
      documentUploadUrl,
      getMateriaById,
      getBrandById,
      imageUploadUrl,
      videoUploadUrl,
      supplyNameFun,
      shipTolocationPinCode,
      clientBillingAddress
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PostSalesApartment);
